import { styled } from "goober";

export const ModalContent = styled("div")`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ModalHead = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ModalRows = styled("div")`
  display: flex;
  flex-direction: column;
  border: 0.5px solid var(--border-alpha);
  border-radius: 12px;
  background: var(--surface-secondary);
`;

export const ModalRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;

  &:not(:last-child) {
    border-bottom: 0.5px solid var(--border-alpha);
  }
`;

export const ModalRowText = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ModalFooter = styled("div")`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const MODAL_CARD_SHELL_STYLE = {
  width: 420,
  maxWidth: "92vw",
  display: "flex",
  flexDirection: "column",
} as const;

export const STEPPER_INPUT_STYLE = {
  minWidth: 0,
  width: 44,
  textAlign: "center",
  padding: "0 4px",
  flexShrink: 0,
} as const;
